import { defineMessages } from 'react-intl';

type MessageKeys = 'closeButton' | 'headerTitle';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		closeButton: {
			id: 'ai-mate.browse-agents-view.close-button',
			defaultMessage: 'Close agents view',
			description: 'Label shown on the close button in the browse agents view',
		},
		headerTitle: {
			id: 'ai-mate.browse-agents-view.header-title',
			defaultMessage: 'Browse agents',
			description: 'Title shown in the header of the browse agents view',
		},
	});

export default message;
